import { atomFamily, atomWithStorage, createJSONStorage } from "jotai/utils";
const prefix = `debugSetting:`;
export const debugSettingSelector = atomFamily((settingType) => atomWithStorage(`${prefix}${settingType}`, false, createJSONStorage(), {
    getOnInit: true,
}));
//# sourceMappingURL=debugSettingState.js.map